export default "__VITE_ASSET__BDrwUTNT__"